import { Checkbox } from "@/components";
import { CheckboxProvider, Group, GroupLabel } from "@ariakit/react";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import {
	checkBoxStyles,
	colCount,
	cols,
	group,
	label as labelStyles,
} from "./CheckboxGroup.css";
import type { PrimitiveValue, Props } from "./types";

export default function CheckboxGroup({
	options,
	value,
	columns = 1,
	orientation = "vertical",
	label,
	multiple = true,
	onChange,
}: Props) {
	const isChecked = (val: PrimitiveValue) => value?.includes(val) ?? false;
	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { value: val, checked } = e.target;
		if (checked) {
			onChange?.(multiple ? [...(value ?? []), val] : [val]);
		} else {
			onChange?.(multiple ? (value?.filter((v) => v !== val) ?? []) : []);
		}
	};
	return (
		<CheckboxProvider<PrimitiveValue[]>
			defaultValue={[options[0]?.value]}
			value={value}
		>
			<Group
				className={group({ orientation, withLabel: !!label })}
				style={assignInlineVars({
					[cols]: Array.from({ length: columns }, () => "1fr").join(" "),
					[colCount]: `${columns}`,
				})}
			>
				{label && (
					<GroupLabel className={labelStyles({ orientation })}>
						{label}
					</GroupLabel>
				)}
				{options.map((o) => (
					<Checkbox
						key={o.value}
						value={o.value}
						onChange={handleChange}
						checked={isChecked(o.value)}
						disabled={o.disabled}
						className={checkBoxStyles({ orientation })}
					>
						{o.label}
					</Checkbox>
				))}
			</Group>
		</CheckboxProvider>
	);
}
